import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleCalendarColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_25083_2062)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8.8961 14.9026C8.5027 14.6368 8.2303 14.2487 8.0816 13.7355L8.9948 13.3592C9.0777 13.675 9.2224 13.9197 9.429 14.0934C9.6343 14.2671 9.8843 14.3526 10.1764 14.3526C10.4751 14.3526 10.7317 14.2618 10.9461 14.0802C11.1605 13.8986 11.2685 13.667 11.2685 13.3868C11.2685 13.1 11.1553 12.8657 10.929 12.6842C10.7027 12.5027 10.4185 12.4118 10.079 12.4118H9.5514V11.5079H10.025C10.3171 11.5079 10.5632 11.429 10.7632 11.2711C10.9632 11.1132 11.0632 10.8974 11.0632 10.6224C11.0632 10.3777 10.9737 10.1829 10.7948 10.0369C10.6159 9.89088 10.3895 9.81718 10.1145 9.81718C9.8461 9.81718 9.6329 9.88828 9.475 10.0317C9.3171 10.1751 9.2026 10.3514 9.1303 10.5593L8.2264 10.183C8.3461 9.84348 8.5659 9.54348 8.8882 9.28428C9.2106 9.02508 9.6224 8.89478 10.1224 8.89478C10.4921 8.89478 10.825 8.96588 11.1198 9.10928C11.4145 9.25268 11.6461 9.45138 11.8132 9.70398C11.9803 9.95788 12.0632 10.2422 12.0632 10.5579C12.0632 10.8803 11.9856 11.1526 11.8303 11.3763C11.675 11.6 11.4842 11.771 11.2579 11.8908V11.9447C11.5566 12.0697 11.8 12.2605 11.9921 12.5171C12.1829 12.7737 12.2789 13.0803 12.2789 13.4382C12.2789 13.7961 12.1881 14.1158 12.0065 14.3961C11.8249 14.6764 11.5736 14.8974 11.2552 15.0579C10.9355 15.2184 10.5763 15.3 10.1776 15.3C9.7158 15.3013 9.2895 15.1684 8.8961 14.9026Z",
				fill: "#1A73E8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.5 10.371L13.5026 11.096L13.0013 10.3355L14.8 9.03809H15.4895V15.1578H14.5V10.371Z",
				fill: "#1A73E8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2632 22.0001L22 17.2633L19.6316 16.2107L17.2632 17.2633L16.2106 19.6317L17.2632 22.0001Z",
				fill: "#EA4335"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.6842 19.6316L6.7368 22H17.2631V17.2632H6.7368L5.6842 19.6316Z",
				fill: "#34A853"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.5789 2C2.7066 2 2 2.7066 2 3.5789V17.2631L4.3684 18.3157L6.7368 17.2631V6.7368H17.2631L18.3157 4.3684L17.2632 2H3.5789Z",
				fill: "#4285F4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2 17.2632V20.4211C2 21.2935 2.7066 22 3.5789 22H6.7368V17.2632H2Z",
				fill: "#188038"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2632 6.73668V17.263H22V6.73668L19.6316 5.68408L17.2632 6.73668Z",
				fill: "#FBBC04"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22 6.7368V3.5789C22 2.7065 21.2934 2 20.4211 2H17.2632V6.7368H22Z",
				fill: "#1967D2"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_25083_2062",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white",
			transform: "translate(2 2)"
		})
	}) })]
});
export default SvgGoogleCalendarColor;
